module.exports = __webpack_public_path__ + "static/img/MacBookPro13.8e0b23a0.png";